import { gql } from "@apollo/client";

export const GET_PURCHASE_ORDER_PDF = gql`
  mutation GetPurchaseOrderPDF($_id: String!) {
    purchaseOrderPDF(_id: $_id)
  }
`;
